export const defectMagnitude = d => Number.isFinite(d.height) ? Math.abs(d.height) : null;
export const defectLabel = d => defectMagnitude(d)?.toFixed(2) ?? '—';
export function filterDefects(defects, showBumps, showDips, minimum) {
  return defects.filter(d => (d.type === 'bump' ? showBumps : showDips) && (minimum <= 0 || (defectMagnitude(d) !== null && defectMagnitude(d) >= minimum)));
}
export function markerIcon(d) {
  const bump = d.type === 'bump';
  const magnitude = defectLabel(d);
  const fontSize = magnitude.length > 4 ? Math.max(8, 52 / magnitude.length) : 14;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="52" viewBox="0 0 64 52"><path d="${bump ? 'M32 3L61 49H3Z' : 'M3 3H61L32 49Z'}" fill="${bump ? '#ffac32' : '#bf83ef'}" stroke="white" stroke-width="2.5" stroke-linejoin="round"/><text x="32" y="${bump ? 38 : 23}" text-anchor="middle" font-family="Arial,sans-serif" font-weight="bold" font-size="${fontSize}" fill="#17202a">${magnitude}</text></svg>`;
  return { url: `data:image/svg+xml,${encodeURIComponent(svg)}`, width:64,height:52,anchorX:32,anchorY:26 };
}
